import { useMemo, useState } from 'react';
import { useDifferimentInvoices } from '../../../../hooks/useDifferimentInvoices';

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getCurrentMonthRange = () => {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return {
    startDate: formatDate(start),
    endDate: formatDate(end),
  };
};

export const useDifferimentInvoicesTable = () => {
  const defaultRange = getCurrentMonthRange();
  const [filters, setFilters] = useState({
    startDate: defaultRange.startDate,
    endDate: defaultRange.endDate,
    contractNumber: '',
    page: 1,
    limit: 15,
    totalCount: 0,
  });

  const { data = [], isFetching, refetch } = useDifferimentInvoices(filters, { enabled: true });
  const rows = useMemo(() => data || [], [data]);
  const totalCount = filters.totalCount || rows.length;
  const totalPages = Math.max(1, Math.ceil(totalCount / filters.limit));

  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value, ...(key !== 'page' ? { page: 1 } : {}) }));
  };

  const handleFetch = () => {
    refetch();
  };

  return {
    filters,
    rows,
    isFetching,
    totalCount,
    totalPages,
    handleChange,
    handleFetch,
  };
};

export default useDifferimentInvoicesTable;
